<script setup lang="ts">
import {computed} from "vue";
import {DropDownList} from "@progress/kendo-vue-dropdowns";
import {useUxData} from "@/stores/ux-data";

const emit = defineEmits(['severitySelected'])
const props = defineProps<{
  placeholder: string | undefined,
  // Optional controlled selection (the severity type, or null for none).
  // Omitted → uncontrolled.
  selected?: string | null,
}>()

const ux = useUxData();

const severityItems = computed(() => [
  { label: ux.labels.swade.data.hindrances.types.minor, type: 'minor' },
  { label: ux.labels.swade.data.hindrances.types.major, type: 'major' },
])

const valueBinding = computed(() =>
  props.selected === undefined
    ? {}
    : { value: severityItems.value.find((item) => item.type === props.selected) ?? null }
)

const onChange = (event: any) => {
  emit('severitySelected', event);
}
</script>

<template>
  <DropDownList
      text-field="label"
      value-field="type"
      class="text-center"
      :placeholder="placeholder"
      :default-item="{
        label: props.placeholder,
        type: null,
      }"
      :data-items="severityItems"
      v-bind="valueBinding"
      @change="onChange"
  />
</template>
